import { DESC } from '@/components/shells/table/sort-directions';

const propsFunc = (record, column) => {
	return {
		labelText: record[column.columnName]
	};
};

const eventsFunc = (record, column, dynamicComponentEventHandler) => {
	return {
		click: () => {
			dynamicComponentEventHandler('onOperationClick', record);
		}
	};
};

const componentDef = {
	name: 'Hyperlink',
	props: propsFunc,
	events: eventsFunc
};

export default [
	{
		columnName: 'id',
		columnDisplayName: 'Repair Order Operation Id',
		display: false
	},
	{
		columnName: 'roNumber',
		columnDisplayName: 'RO #',
		columnModifierName: 'ro-number',
		display: true,
		isSortable: true
	},
	{
		columnName: 'operation',
		columnDisplayName: 'Op',
		columnModifierName: 'operation',
		display: true,
		isSortable: true,
		component: componentDef
	},
	{
		columnName: 'repairOrderDateCreated',
		columnDisplayName: 'Opened',
		columnModifierName: 'date-created',
		slot:'created',
		display: true,
		isSortable: true,
		sortDirection: DESC,
	},
	{
		columnName: 'serviceAccountCode',
		columnDisplayName: 'Service Account Code',
		columnModifierName: 'account-code',
		display: true,
		isSortable: true
	},
	{
		columnName: 'opCode',
		columnDisplayName: 'Op Code',
		columnModifierName: "op-code",
		display: true,
		isSortable: true
	},
	{
		columnName: 'concern',
		columnDisplayName: 'Concern',
		columnModifierName: 'concern',
		display: true,
		isSortable: false
	}
];
